import React from 'react';

interface UserIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const UserIcon: React.FC<UserIconProps> = ({ 
  width = 26, 
  height = 26, 
  className 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 26 26" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M13.0003 10.8337C15.3936 10.8337 17.3337 8.89356 17.3337 6.50033C17.3337 4.10709 15.3936 2.16699 13.0003 2.16699C10.6071 2.16699 8.66699 4.10709 8.66699 6.50033C8.66699 8.89356 10.6071 10.8337 13.0003 10.8337Z" 
        fill="#CFCFCF"
      />
      <path 
        d="M21.6663 18.958C21.6663 21.6504 21.6663 23.833 12.9997 23.833C4.33301 23.833 4.33301 21.6504 4.33301 18.958C4.33301 16.2656 8.2132 14.083 12.9997 14.083C17.7862 14.083 21.6663 16.2656 21.6663 18.958Z" 
        fill="#CFCFCF"
      />
    </svg>
  );
};